import { AlertVariant, AlertStyleVariant, useAlert } from '@lwtears/lwt-common-frontend/lib/Alert';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import InfoIcon from '@mui/icons-material/Info';

const useActivityCompletionAlert = (
  handleRestartActivity: () => void,
  handleCloseActivity: () => void,
  body: React.ReactNode,
  duration?: number | null
): { handleActivityCompletionAlert: () => void } => {
  const [, { openAlert, closeAlert }] = useAlert();
  const [, { closeModal }] = useModal();

  const classes = useStyles();

  const handleOpeningSuccessAlert = (body: any, actionButton?: any) => {
    closeModal();
    openAlert({
      body,
      variant: AlertVariant.SUCCESS,
      styleVariant: AlertStyleVariant.OUTLINED,
      options: {
        classes: {
          icon: classes.icon,
          root: classes.alertRoot,
        },
        duration,
        disableClickAwayListener: true,
      },
      alertProps: {
        icon: <InfoIcon />,
      },
      action: actionButton,
    });
  };

  const ActionButton = (
    <Box className={classes.alertActionButtons}>
      <Button
        className={classes.alertRestartButton}
        onClick={() => {
          closeAlert();
          handleRestartActivity();
        }}
      >
        {tA11y('buttons.restart')}
      </Button>
      <Button
        onClick={() => {
          closeAlert();
          handleCloseActivity();
        }}
      >
        {tA11y('buttons.close')}
      </Button>
    </Box>
  );

  const handleActivityCompletionAlert = () => handleOpeningSuccessAlert(body, ActionButton);

  return { handleActivityCompletionAlert };
};

const useStyles = makeStyles((theme: any) => ({
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alertRoot: {
    backgroundColor: theme.palette.success.lighter,
    color: theme.palette.black.main,
  },
  alertActionButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'space-between',
    marginLeft: theme.spacing(5),
  },
  alertRestartButton: {
    color: theme.palette.primary.main,
  },
  alertBody: {
    marginTop: 5,
  },
}));

export default useActivityCompletionAlert;
